// extracted by mini-css-extract-plugin
export default {"h3":"nJNABa9feLTfs540ysmG","bold":"ir3DHcUS42RHUCWJZp0A","pink":"QWwyhDAZiUQhyOxG0UIP"};